module.exports = __webpack_public_path__ + "img/大事记ico2.69ad8247.png";